export const eventsEnLocale = {
  'eventPage.list': 'List',
  'eventPage.calendar': 'Calendar',
  'eventPage.title': 'Available dates',
  'eventPage.buy': 'Find tickets',

  'eventPage.description': 'Choose a date to see available tickets',

  'eventPage.loading': 'Loading dates...',
} as const;

export const eventsEsLocale = {
  'eventPage.list': 'Lista',
  'eventPage.calendar': 'Calendario',
  'eventPage.title': 'Fechas disponibles',
  'eventPage.buy': 'Comprar',

  'eventPage.description': 'Elige una fecha para ver los tickets disponibles',

  'eventPage.loading': 'Cargando fechas...',
} as const;
